import React from 'react';
import styled, { keyframes } from 'styled-components';

const loadingDot = keyframes`
    from {
        transform: scale(0,0);
    }
    to {
        transform: scale(1,1);
    }
`;

const LoadingDots = styled.div`
    display: flex;
    align-items: center;
`;

const LoadingDot = styled.span`
    margin: 0 0.25rem;
    background: currentColor;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    animation: ${loadingDot} 0.6s alternate infinite;

    &:nth-of-type(2) {
        animation-delay: 200ms;
    }
    &:nth-of-type(3) {
        animation-delay: 400ms;
    }
`;

const IconLoadingDots = () => (
    <LoadingDots>
        <LoadingDot />
        <LoadingDot />
        <LoadingDot />
    </LoadingDots>
);

export default IconLoadingDots;
